<template>
    <div class="content">
       <a-spin :spinning="liveSpinning">
            <a-table 
                :rowKey="(record,index)=>{return index}"
                :columns="columns"
                :data-source="dataSource" 
                bordered
            >

            <div slot="id" slot-scope="text,record,index">
                <span style="color:blue;cursor: pointer;" @click="goodsDetail(record.goods)">{{ record.id }}</span>
            </div>
            
            <div slot="orderStatus" slot-scope="text,record,index">
                <span v-if="record.orderStatus===0">取消</span>
                <span v-else-if="record.orderStatus===1">进行中</span>
                <span v-else-if="record.orderStatus===2">已完成</span>
            </div>

            <div slot="deliveryStatus" slot-scope="text,record,index">
                <span v-if="record.deliveryStatus===0">未发货</span>
                <span v-else-if="record.deliveryStatus===1">已发货</span>
            </div>

            <div slot="tradeStatus" slot-scope="text,record,index">
                <span v-if="record.tradeStatus===0">待支付</span>
                <span v-else-if="record.tradeStatus===1">已支付</span>
            </div>
            
                <template slot="Pay" slot-scope="text,record,index">
                    <a-button v-if="record.tradeStatus===0 && record.orderStatus===1" @click="Pay(record.id)" style="background: #2caf7a;color:#fff;">支付</a-button>
                    <a-button v-if="record.orderStatus!==0" @click="orderCental(record.id)" style="background: #2caf7a;color:#fff;">取消</a-button>
                </template>
            </a-table>
       </a-spin>

       <!-- 商品详情弹窗 -->
        <a-modal
            title="订单详情"
            :visible="visibleGoods"
            @cancel="handleCancel"
            width="60%"
            >
            <a-table 
                :rowKey="(record,index)=>{return index}"
                :columns="columnsGoods"
                :data-source="dataSourceGood" 
                bordered
            />

            <template slot="footer">
                <a-button @click="handleCancel">关闭</a-button>
            </template>
           
        </a-modal>
    </div>
</template>

<script>
export default{
    name:'OrderMessage',
    props:['dataSource'],
    data:function(){
        return{
            columns: [
                {
                    align: 'center',
                    title: '序号',
                    customRender: (text,record,index) => `${index+1}`
                }, 
                {
                    align: 'center',
                    title: '订单编号',
                    dataIndex: 'id',
                    scopedSlots: { customRender: 'id' }
                }, 
                {
                    align: 'center',
                    title: '订单金额',
                    dataIndex: 'orderPrice'
                },
                {
                    align: 'center',
                    title: '下单时间',
                    dataIndex: 'createTime',
                },
                {
                    align: 'center',
                    title: '发货状态',
                    dataIndex: 'deliveryStatus',
                    scopedSlots: { customRender: 'deliveryStatus' }
                },
                {
                    align: 'center',
                    title: '订单状态',
                    dataIndex: 'orderStatus',
                    scopedSlots: { customRender: 'orderStatus' }
                },
                {
                    align: 'center',
                    title: '付款状态',
                    dataIndex: 'tradeStatus',
                    scopedSlots: { customRender: 'tradeStatus' }
                },
                {
                    align: 'center',
                    title: '备注',
                    dataIndex: 'remark'
                },
                {
                    align: 'center',
                    title: '操作',
                    dataIndex: 'Pay',
                    scopedSlots: { customRender: 'Pay' }
                }
            ],

            columnsGoods: [
                {
                    align: 'center',
                    title: '序号',
                    customRender: (text,record,index) => `${index+1}`
                }, 
                {
                    align: 'center',
                    title: '教材名称',
                    dataIndex: 'materialTitle'
                },  
                {
                    align: 'center',
                    title: '单价',
                    dataIndex: 'goodsPrice'
                }, 
                {
                    align: 'center',
                    title: '商品数量',
                    dataIndex: 'totalNum'
                },
                {
                    align: 'center',
                    title: '总价',
                    dataIndex: 'totalPrice'
                }
            ],
            liveSpinning:true,
            visibleGoods: false,
            dataSourceGood:[]
            
        } 
    },
    mounted(){
        this.$emit('ChangeTab')
        this.liveSpinning = false
    },

    methods:{
        // 商品详情
        goodsDetail(goods){
            this.visibleGoods = true
            this.dataSourceGood = goods
        },

        handleCancel(){
            this.visibleGoods = false
        },
        
        Pay(id){
            let params = '/biz/material/order/pay'+'?orderId='+id
            this.axios.get(params).then(res => {
                if (res.code === 200) {
                    localStorage.setItem('params',JSON.stringify(res.result.param))
                    localStorage.setItem('Url',res.result.url)
                    // this.$store.state.receiveData = []
                    this.$emit('ChangeTab')
                    // this.$message.success(res.result)
                    this.$router.push(`/personalcenters/orderpay`);
                }
            })
        },

        //取消
        orderCental(id){
            this.liveSpinning = true
            let params = '/biz/material/order/cancel'+'?orderId='+id
            this.axios.get(params).then(res => {
                if(res.code === 200){
                    
                    this.$message.success(res.result)
                    this.$emit('ChangeTab')
                    this.liveSpinning = false
                }
            })
        }
    }
}
</script>

<style lang="stylus" scoped>
.content{
    padding:10px;
}
</style>


// WEBPACK FOOTER //
// src/pages/textbookOrder/OrderMessage.vue